import { Route, Routes } from 'react-router-dom';
import CakeCategory from './Categories';
import CakeSubCategory from './SubCategories';
import CakeFlavour from './Flavours';
import CakeShape from './Shapes';
import CakeProduct from './Products';
import Order from './Orders';
import CategoryDisplay from './order-screens/CategoryDisplay';
import SubCategoryDisplay from './order-screens/SubCategoryDisplay';
import ProductDisplay from './order-screens/ProductDisplay';
import OrderDisplay from './order-screens/OrderDisplay';
import Catalogue from './order-screens/Catalogue';
import Reviews from './order-screens/Reviews';
import FestivalNamkeenOrder from './order-screens/FestivalNamkeenOrder';
import NamkeenOrder from './NamkeenOrder';
import NamkeenOrderBlocks from './NamkeenOrderBlocks';
import NaturalColorsDisplay from './order-screens/NaturalColorsDisplay';

function CakeRoutes() {
  return (
    <Routes>
      <Route path="categories" element={<CakeCategory />} />
      <Route path="sub-categories" element={<CakeSubCategory />} />
      <Route path="flavours" element={<CakeFlavour />} />
      <Route path="shapes" element={<CakeShape />} />
      <Route path="products" element={<CakeProduct />} />
      <Route path="orders" element={<Order />} />
      <Route path="home" element={<CategoryDisplay />} />
      <Route path="sub-categories-display/:categoryId" element={<SubCategoryDisplay />} />
      <Route path="product-display/:categoryId/:subCategoryId" element={<ProductDisplay />} />
      <Route path="order-display/:categoryId/:subCategoryId/:productId" element={<OrderDisplay />} />
      <Route path="catalogue" element={<Catalogue />} />
      <Route path="reviews" element={<Reviews />} />
      <Route path="natural-colors" element={<NaturalColorsDisplay />} />
      <Route path="create-namkeen-orders" element={<FestivalNamkeenOrder />} />
      <Route path="namkeen-orders" element={<NamkeenOrder viewType={'orderDetails'} />} />
      <Route path="namkeen-dc-details" element={<NamkeenOrder viewType={'dcDetails'} />} />
      <Route path="rejected-namkeen-orders" element={<NamkeenOrder viewType={'rejectedOrderDetails'} />} />
      <Route path="namkeen-order-blocks" element={<NamkeenOrderBlocks />} />
    </Routes>
  );
}

export default CakeRoutes;
